import { SiteControllerType } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingBaseFormModel } from "@/components/features/settings/site-controller/model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "@/components/features/settings/site-controller/model/base/use-case/use-create-model/methods";

import { SelectField } from "@/components/ui/form/fields/select-field";

import { useSiteControllerBaseSiteControllerType } from "./hooks";

type Props = {
	hotelID: string;
	siteControllerType: SiteControllerSettingBaseFormModel["ViewModel"]["siteControllerType"]; //
	onSetSiteControllerType: SiteControllerSettingBaseFormModelMethodsType["siteControllerSettingBaseFormModelMethods"]["onSetSiteControllerType"];
};

export const SettingsSiteControllerBaseSiteControllerType = ({
	hotelID,
	siteControllerType: _siteControllerType,
	onSetSiteControllerType: _onSetSiteControllerType,
}: Props) => {
	const { siteControllerType, siteControllerTypeOptions, onSetSiteControllerType } =
		useSiteControllerBaseSiteControllerType({
			hotelID,
			siteControllerType: _siteControllerType,
			onSetSiteControllerType: _onSetSiteControllerType,
		});

	return (
		<QuestionForMain
			required={true}
			title={"利用するサイトコントローラー"}
			belowTitleChildren={
				// ねっぱん・手間いらずはプラン連携に対応しているため
				siteControllerType.value === SiteControllerType.Neppan ||
				siteControllerType.value === SiteControllerType.Temairazu ? (
					<p className="text-sm text-error-600">
						CHILLNNで作成したプランを
						{siteControllerType.value === SiteControllerType.Neppan ? "ねっぱん" : "手間いらず"}
						と料金連携している場合、サイトコントローラーを変更すると、
						<br />
						該当プランの料金設定は無効になり自動的に非公開になります。
						<br />
						変更後、あらためて料金を設定し直した上で、公開に戻してください。
					</p>
				) : undefined
			}
			inputChildren={
				<div className="w-1/2 space-y-4 xl:w-1/4">
					{siteControllerType.value === "未選択" && (
						<div className="flex items-center gap-2 text-brand">
							<p className="text-gray-500 text-sm">在庫や料金を管理する方法を選択してください</p>
						</div>
					)}

					<SelectField
						value={siteControllerType.value}
						options={siteControllerTypeOptions}
						handleValueChange={onSetSiteControllerType}
					/>
				</div>
			}
		/>
	);
};

SettingsSiteControllerBaseSiteControllerType.displayName = "SettingsSiteControllerBaseSiteControllerType";
